<template>
  <v-card class="d-flex align-start px-3 py-5 pa-sm-6 rounded-xl">
    <v-card-title class="pa-0">
      <v-btn
        color="#fef3c6"
        :height="xsOnly ? 40 : 48"
        :width="xsOnly ? 40 : 48"
        depressed
        fab
      >
        <v-icon color="#e17100" :size="xsOnly ? 20 : 24">
          mdi-information-outline
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="pa-0 ml-3 ml-sm-4 mt-n1">
      <div class="black--text text-subtitle-1 text-sm-h6 font-weight-bold">
        Descartar alterações
      </div>

      <div
        class="grey--text text--darken-2 text-body-2 text-sm-body-1 mt-1 delete-text"
      >
        <div>
          Você tem alterações não salvas. Se sair agora, todas as informações
          inseridas serão perdidas.
        </div>
      </div>

      <div class="d-flex justify-end mt-3 mt-sm-5">
        <v-btn
          @click.prevent="$emit('close')"
          class="rounded-lg"
          color="#dddddd"
          :disabled="loading"
          :small="xsOnly"
          outlined
          dense
        >
          <div class="black--text text-none">
            {{ itemId ? "Continuar editando" : "Continuar cadastro" }}
          </div>
        </v-btn>

        <v-btn
          @click="$router.go(-1)"
          class="rounded-lg ml-2"
          color="#e17100"
          :loading="loading"
          :small="xsOnly"
          depressed
          dense
        >
          <div class="white--text text-none">Descartar e sair</div>
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  computed: {
    itemId() {
      return this.$route.params.id || null;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
};
</script>

<style lang="scss" scoped>
.delete-text {
  line-height: 1.3 !important;

  div:first-child {
    margin-bottom: 2px;
  }
}
</style>
